<template>
  <div class="templatebody" :style="note">
    <div>
      <Userheard></Userheard>
    </div>
    <div
      class="content-margin"
      style="background-color: #002336; padding: 1%1%; text-align: center"
    >

      <el-steps :active="active" align-center>
        <el-step title="已订舱" :description="allData.state_dc_time" :class="key1" icon="el-icon-upload">
          <i class="step01" slot="icon"></i>
        </el-step>

        <el-step
          title="已发出"
          icon="el-icon-upload"
          :description="allData.state_fc_time"
          :class="key2"
        >
          <i class="step02" slot="icon"></i>
        </el-step>
        <el-step
          title="已收货"
          icon="el-icon-picture"
          :description="allData.state_sh_time"
          :class="key3"
        >
          <i class="step03" slot="icon"></i>
        </el-step>
        <el-step
          title="已安检"
          icon="el-icon-picture"
          :description="allData.state_aj_time"
          :class="key4"
        >
          <i class="step04" slot="icon"></i>
        </el-step>
        <el-step
          title="已入库"
          icon="el-icon-picture"
          :description="allData.state_rk_time"
          :class="key10"
        >
          <i class="step10" slot="icon"></i>
        </el-step>
        <el-step
          title="已组板"
          icon="el-icon-picture"
          :description="allData.state_zb_time"
           :class="key5"
        >
          <i class="step05" slot="icon"></i>
        </el-step>
        <el-step
          title="已起飞"
          icon="el-icon-picture"
          :description="allData.state_qf_time"
          :class="key6"
        >
          <i class="step06" slot="icon"></i>
        </el-step>
        <el-step
          title="已落地"
          icon="el-icon-picture"
          :description="allData.state_ld_time"
          :class="key7"
        >
          <i class="step07" slot="icon"></i>
        </el-step>
        <el-step
          title="已提货"
          icon="el-icon-picture"
          :description="allData.state_th_time"
          :class="key8"
        >
          <i class="step08" slot="icon"></i>
        </el-step>
        <el-step
          title="已完成"

          icon="el-icon-picture"
          :description="allData.state_wc_time"
          :class="key9"
        >
          <i class="step09" slot="icon"></i>
        </el-step>
      </el-steps>
    </div>
    <div style="margin: 0% 8%; padding: 1%3%; background-color: #ffffff;position:relative">
      <!-- 飞机信息 -->
      <div
        class="flex-all-center"
        style="background-color: #f7f7f7; border: 1px solid rgb(225, 225, 224)"
      >
        <div style="width: 20%; padding: 1% 2%;">
          <div style="border-right:1px solid #ccc">
            <p
              style="font-size: 20px; padding-bottom: 2%"
              class="text-dackblue"
            >
              {{ orderId }}
            </p>
          </div>
          <div style="border-right:1px solid #ccc;font-size: 16px;"  :title="allData.partner_name">
            <el-tag effect="dark" class="kh" >客户：{{ allData.partner_name }}</el-tag>
          </div>

          <div   :title="allData.create_service">
            <p style="padding-top: 2%; font-size: 16px;border-right:1px solid #ccc" class="create">
              创建服务商：{{ allData.create_service }}
            </p>

          </div>

        </div>
        <div style="width: 60%; padding: 1%2%" class="flex-all-center">
          <div
            style="
              width: 30%;
              display: flex;
              justify-content: center;
              flex-direction: column;
            "
          >
            <div>
              <p class="f1">
                预飞：{{allData.route_list.length>0?  allData.route_list[0].plan_depart_time : ''}}
              </p>
            </div>
            <div>
              <p style=" padding: 3% 0%" class="f2">
                {{ allData.depart_port_name_cn }}({{
                  allData.depart_port_three_no
                }})
              </p>
            </div>
            <div>
              <p class="f1">
                实飞：{{ allData.actual_depart_time }}
              </p>
            </div>
          </div>
          <div
            style="
              width: 40%;
              display: flex;
              justify-content: center;
              flex-direction: column;
              color:#999
            "
          >
            <!-- <p  class="" v-if="allData.plan_transfer_time" style="font-size:0.078125rem">
              预转：{{ allData.plan_transfer_time }}
            </p>
            <p style=" padding: 3%0%" class="f3" v-if="allData.route_list.length>2">
              —— {{ allData.transfer_port_name_cn }}({{
                allData.transfer_port_three_no
              }}) ——
            </p> -->
            <p v-if='allData.stop_over_num'>
              ------------ 中转{{allData.stop_over_num}}次 -----------------
            </p>
            <p v-else>
              -----------------------------
            </p>
            <!-- <p class="" v-if="allData.actual_transfer_time" style="font-size:0.078125rem">
              实转：{{ allData.actual_transfer_time }}
            </p>
            <p v-if="!allData.actual_transfer_time">
                   &nbsp;&nbsp;
            </p> -->

          </div>
          <div
            style="
              width: 30%;
              display: flex;
              justify-content: center;
              flex-direction: column;

            "
          >
            <p class="f1">预达：{{allData.route_list.length>0?  allData.route_list[allData.route_list.length-1].plan_arrive_time : ''}}</p>
            <p style=" padding: 3% 0%;" class="f2">
              {{ allData.arrive_port_name_cn }}({{
                allData.arrive_port_three_no
              }})
            </p>
            <p class="f1">
              实达：{{ allData.actual_arrive_time }}
            </p>
          </div>
        </div>
        <div
          style="
            width: 20%;
            padding: 1% 2%;
            display: flex;

            flex-direction: column;

          "
        >
          <p style="font-size: 18px ; border-left:1px solid #ccc;line-height:55px;text-align:left;text-indent:3.5em">
            航班号：{{ allData.voyage_name }}
          </p>
          <p style="font-size: 18px ;border-left:1px solid #ccc;text-align:left;text-indent:3.5em;line-height:36px">
            航次号：{{ allData.voyage_number }}
          </p>
        </div>
      </div>
    </div>
    <!-- 操作记录 -->
    <div
      style="
        margin: 0%8%;
        padding: 1% 3% 2% 3%;

        background-color: #ffffff;
        display: flex;
        justify-content: center;
      "
    >
      <div style="width: 65%; background-color: #f7f7f7">
        <div class="table">
          <el-table
            border
            stripe
            :row-class-name="tableRowClassName"
            :header-cell-style="getRowClass"
            :data="tableData"

            height="450"

          >
            <el-table-column prop="description" label="操作描述" min-width="80">
            </el-table-column>
            <el-table-column prop="operation_time" label="时间" width="180">
            </el-table-column>
            <el-table-column prop="time_zone" label="时区" width='70'>
            </el-table-column>
            <el-table-column prop="address" label="地点" show-overflow-tooltip min-width="100"> </el-table-column>
            <el-table-column
              prop="operation_object"
              label="操作对象"
              show-overflow-tooltip
              min-width="100"
            >
            </el-table-column>
            <el-table-column prop="service" label="服务商" show-overflow-tooltip min-width="100">
            </el-table-column>
            <el-table-column prop="remark" label="备注" show-overflow-tooltip min-width="100">
            </el-table-column>
          </el-table>
        </div>

        <div></div>
      </div>
      <!-- 卡车记录 -->
      <div
        style="
          width: 30%;
          margin-left: 5%;
          background-color: #f7f7f7;
          padding: 32px ;

        "
      >
        <div style="display: flex; align-items: center">
          <div
            :style='open'
            class="flex-text-center"
            @click="head"
          >
            <p >头程卡运</p>
          </div>
          <div
            :style="off "
            class="flex-text-center"
            @click="foot"
          >
            <p >尾程卡运</p>
          </div>
        </div>

        <div style="font-size:12px">
          <div >
            <el-row class="bor-bottom bor-left bor-right" style="padding: 2%0%">
              <el-col :span="8" class="rightp" style="margin: 1%0%">
                <p class="text-dackblue">卡运单号：</p>
              </el-col>
              <el-col :span="15" :offset="1" class="leftp">
                <p v-if="flag == 'head' && allData.coll_res.truck_no">
                  {{ allData.coll_res.truck_no }}
                </p>
                <p v-if="flag == 'foot' && allData.give_res.truck_no">
                  {{ allData.give_res.truck_no }}
                </p>
              </el-col>
            </el-row>
          </div>
          <div>
            <el-row class="bor-bottom bor-left bor-right" style="padding: 2%0%">
              <el-col :span="8" class="rightp" style="margin: 1%0%">
                <p class="text-dackblue">卡车车牌：</p>
              </el-col>
              <el-col :span="15" :offset="1" class="leftp">
                <p v-if="flag == 'head'">{{ allData.coll_res.c_truck_name }}</p>
                <p v-if="flag == 'foot'">{{ allData.give_res.g_truck_name }}</p>
              </el-col>
            </el-row>
          </div>
           <div>
            <el-row class="bor-bottom bor-left bor-right" style="padding: 2%0%">
              <el-col :span="8" class="rightp" style="margin: 1%0%">
                <p class="text-dackblue">预计揽收时间：</p>
              </el-col>
              <el-col :span="15" :offset="1" class="leftp">
                <p v-if="flag == 'head'">
                  {{ allData.coll_res.expect_coll_time }}
                </p>
                <p v-if="flag == 'foot'">
                  {{ allData.give_res.expect_coll_time }}
                </p>
              </el-col>
            </el-row>
          </div>
          <div>
            <el-row class="bor-bottom bor-left bor-right" style="padding: 2%0%">
              <el-col :span="8" class="rightp" style="margin: 1%0%">
                <p class="text-dackblue">预计送达时间：</p>
              </el-col>
              <el-col :span="15" :offset="1" class="leftp">
                <p v-if="flag == 'head'">
                  {{ allData.coll_res.expect_give_time }}
                </p>
                <p v-if="flag == 'foot'">
                  {{ allData.give_res.expect_give_time }}
                </p>
              </el-col>
            </el-row>
          </div>

          <div>
            <el-row class="bor-bottom bor-left bor-right" style="padding: 2%0%">
              <el-col :span="8" class="rightp" style="margin: 1%0%">
                <p class="text-dackblue">揽收地点：</p>
              </el-col>
              <el-col :span="15" :offset="1" class="leftp">
                <p v-if="flag == 'head'">{{ allData.coll_res.coll_address }}</p>
                <p v-if="flag == 'foot'">{{ allData.give_res.coll_address }}</p>
              </el-col>
            </el-row>
          </div>
          <div>
            <el-row class="bor-bottom bor-left bor-right" style="padding: 2%0%">
              <el-col :span="8" class="rightp" style="margin: 1%0%">
                <p class="text-dackblue">送达地点：</p>
              </el-col>
              <el-col :span="15" :offset="1" class="leftp">
                <p v-if="flag == 'head'">{{ allData.coll_res.give_address }}</p>
                <p v-if="flag == 'foot'">{{ allData.give_res.give_address }}</p>
              </el-col>
            </el-row>
          </div>

          <div>
            <el-row class="bor-bottom bor-left bor-right" style="padding: 2%0%">
              <el-col :span="8" class="rightp" style="margin: 1%0%">
                <p class="text-dackblue">实际揽收时间：</p>
              </el-col>
              <el-col :span="15" :offset="1" class="leftp">
                <p v-if="flag == 'head'">{{ allData.coll_res.coll_time }}</p>
                <p v-if="flag == 'foot'">{{ allData.give_res.coll_time }}</p>
              </el-col>
            </el-row>
          </div>

          <div>
            <el-row class="bor-bottom bor-left bor-right" style="padding: 2%0%">
              <el-col :span="8" class="rightp" style="margin: 1%0%">
                <p class="text-dackblue">实际送达时间：</p>
              </el-col>
              <el-col :span="15" :offset="1" class="leftp">
                <p v-if="flag == 'head'">{{ allData.coll_res.give_time }}</p>
                <p v-if="flag == 'foot'">{{ allData.give_res.give_time }}</p>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <!-- <el-steps :active="3" align-center>
  <el-step title="步骤1" description="这是一段很长很长很长的描述性文字" icon="el-icon-upload">
    <i class="step02" slot="icon"></i>
  </el-step>
  <el-step title="步骤1" description="这是一段很长很长很长的描述性文字" icon="el-icon-upload">
    <i class="step02" slot="icon"></i>
  </el-step>
  <el-step title="步骤1" description="这是一段很长很长很长的描述性文字" icon="el-icon-upload">
    <i class="step02" slot="icon"></i>
  </el-step>
  <el-step title="步骤1" description="这是一段很长很长很长的描述性文字" icon="el-icon-upload">
    <i class="step02" slot="icon"></i>
  </el-step>
  <el-step title="步骤1" description="这是一段很长很长很长的描述性文字" icon="el-icon-upload">
    <i class="step02" slot="icon"></i>
  </el-step>
  <el-step title="步骤1" description="这是一段很长很长很长的描述性文字" icon="el-icon-upload">
    <i class="step02" slot="icon"></i>
  </el-step>
  <el-step title="步骤1" description="这是一段很长很长很长的描述性文字" icon="el-icon-upload">
    <i class="step02" slot="icon"></i>
  </el-step>
  <el-step title="步骤1" description="这是一段很长很长很长的描述性文字" icon="el-icon-upload">
    <i class="step02" slot="icon"></i>
  </el-step>
  <el-step title="步骤1" description="这是一段很长很长很长的描述性文字" icon="el-icon-upload">
    <i class="step02" slot="icon"></i>
  </el-step>
</el-steps> -->
    <div class="buttom-text">

      <p>
        版权所有：海南云航翊信息科技有限责任公司 Copyright © 2014.Company name All
        rights reserved.
      </p>
    </div>
  </div>
</template>

<script scoped>
import '@/assets/css/home.css'
import '@/assets/css/public.css'
import Userheard from '../public/Userheard.vue'
// import uniBadge from '@dcloudio/uni-ui/lib/uni-badge/uni-badge.vue' //也可使用此方式引入组件
export default {
  components: {
    Userheard
  },
  data () {
    return {
      note: {
        backgroundImage:
          'url(' + require('../../assets/img/bg-plane.png') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 93%',
        backgroundPosition: '0 491px',
        backgroundColor: 'rgb(64,112,136)'
      },
      orderId: '',
      active: 0,
      tableRowClassName: '',
      allData: { coll_res: { truck_no: '' }, give_res: { truck_no: '' } },
      tableData: [],
      flag: 'head',
      key1: '',
      key2: '',
      key3: '',
      key4: '',
      key5: '',
      key6: '',
      key7: '',
      key8: '',
      key9: '',
      key10: '',
      open: 'background-color: #255873;width: 50%;height: 50px ;color:#ffffff;font-size: 12px;font-weight:600',
      off: 'background-color: #407087;width: 50%;height:50px ;color: #ffffff;font-size: 12px;font-weight:600',
      kh: ''
    }
  },
  mounted () {

  },
  watch: {
    flag (newvalue, old) {
      if (newvalue) {

      }
    }
  },
  methods: {
    mouse () {
      this.$refs.customer.style.display = 'block'
    },
    leave () {
      this.$refs.customer.style.display = 'none'
    },
    mouse1 () {
      this.$refs.server.style.display = 'block'
    },
    leave1 () {
      this.$refs.server.style.display = 'none'
    },
    head () {
      this.flag = 'head'
      this.off = 'background-color: #407087;width: 50%;height: 50px;color: #ffffff; font-size: 12px ;font-weight:600'
      this.open = 'background-color:#255873;width: 50%;height: 50px;color:#ffffff;font-size: 12px;font-weight:600'
    },
    foot () {
      this.flag = 'foot'
      this.open = 'background-color: #407087;width: 50%;height: 50px;color: #ffffff;font-size: 12px;font-weight:600'
      this.off = 'background-color: #255873;width: 50%;height: 50px;color:#ffffff;font-size: 12px;font-weight:600'
    },
    getRowClass ({ rowIndex }) {
      if (rowIndex == 0) {
        return 'background:#407087;height:50px'
      } else {
        return ''
      }
    },
    getInfo () {
      let data = {
        order_no: this.orderId
      }
      this.$source
        .post('/v1/flight_order/detail/track', data)
        .then((res) => {
          console.log(res, 667)
          this.allData = res.body.data
          this.tableData = this.allData.time_node_list
          switch (this.allData.state) {
            case '已订舱':
              this.active = 1
              this.key1 = 'best'
              break
            case '已发出':
              this.active = 2
              this.key2 = 'best'
              break
            case '已收货':
              this.active = 3
              this.key3 = 'best'
              break
            case '已安检':
              this.active = 4
              this.key4 = 'best'
              break
            case '已组板':
              this.active = 6
              this.key5 = 'best'
              break
            case '已起飞':
              this.active = 7
              this.key6 = 'best'
              break
            case '已落地':
              this.active = 8
              this.key7 = 'best'
              break
            case '已提货':
              this.active = 9
              this.key8 = 'best'
              break
            case '已完成':
              this.active = 10
              this.key9 = 'best'
              break
            case '已入库' :
              this.active = 4
              this.key10 = 'best'
          }
        }).catch(err => {
          console.log(err, 7773)
        })
    }
  },
  created () {
    if (this.$route.params.id) {
      this.orderId = this.$route.params.id
      localStorage.setItem('orderid', this.orderId)
    } else {
      this.orderId = localStorage.getItem('orderid')
    }

    this.getInfo()
  }
}
</script>
<style  scoped>

.step05,
.step06,

.step08
 {
  width: 41px;
  height: 45px;
  background-size: 100% 100%;

}
.step09{
  width: 50px;
  height: 45px;
  background-size: 90% 85%;
  /* background-position: 1px 5px; */
  background-position: 6px;
  background-repeat: no-repeat;
}
.step02{
  width: 35px;
  height: 45px;
  background-size: 100% 85%;
  background-position-y:3px;
  background-repeat: no-repeat;
}
.step01 {
  background-image: url("~@/assets/img/已订舱.png");
  width: 41px;
  height: 45px;
  background-size: 120% 100%;
}
.step05 {
  background-image: url("~@/assets/img/已订舱.png");
  width: 30px;
  height: 45px;
  background-size: 100% 80%;
  background-repeat: no-repeat;
  background-position: 0 4px ;
}
.step04 {
  background-image: url("~@/assets/img/已订舱.png");
  width: 41px;
  height: 45px;
  background-size: 110% 100%;
  background-repeat: no-repeat;
}
.step10 {
  background-image: url("~@/assets/img/入库管理.png");
  width: 41px;
  height: 45px;
  background-size: 96% 100%;
  background-repeat: no-repeat;
}
.el-step__icon {
  width: 35px;

}
.step02 {
  background-image: url("~@/assets/img/已发出.png");
}
.step03 {
   width: 41px;
  height: 45px;
  background-size: 110% 100%;
  background-image: url("~@/assets/img/已收货.png");
  background-repeat: no-repeat;
  background-position-y: -1px;
}
.step04 {
  background-image: url("~@/assets/img/已安检.png");
}
.step05 {
  background-image: url("~@/assets/img/拼单管理.png");
}
.step06 {
  background-image: url("~@/assets/img/已起飞.png");
}
.step07 {
  width: 41px;
  height: 45px;
  background-image: url("~@/assets/img/降落.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.step08 {
  background-image: url("~@/assets/img/已提货.png");
  background-size: 100% 95%;
  background-repeat: no-repeat;
  background-position-y: 3px;
}
.step09 {
  background-image: url("~@/assets/img/已完成.png");
  background-position-x: 5px;
}
.el-step__icon.is-text {
  border: none;
}

.el-button--primary:focus {
  background-color: #fd9405;
  border-color: #fd9405;
}
/* .el-step__title.is-finish{
  color: #ccc !important;
}
.el-step__description.is-finish{
  color: #ccc !important;
} */
.el-form-item__label {
  font-size: 18px;
  color: #ffffff;
}

.el-tag {
  padding: 0%15%;
  font-size: 16px ;
  height: 26px;
  line-height: 26px;
}

.el-tag--dark {
  background-color: #3f6f86;
  border-color: #3f6f86;
  color: #fff;
}

*/  .el-step__icon   .is-icon {
  background: none !important;
}
/* 总样式 */
>>>.el-step__icon {
  background: transparent !important;
}

.el-step__line {
  background-color: transparent;
}

/* 未选中 */
.is-wait > .el-step__line {
  border-top: dotted;
}

.is-process {
  color: #c0c4cc;
  border-color: #c0c4cc;
}

/* 位于这一步 */
.is-finish {
  color: #c0c4cc;
  border-color: #c0c4cc;
}
*/

	/* .is-finish.el-step__line {
		border-top: dotted;
	}

	/* 下一步 */
 .el-step__title  .is-process {
  color: #c0c4cc ;
  border-color: #c0c4cc;
}
  >>> .is-process{
  color: #c0c4cc !important;
}
 .el-step__description.is-process {
  color: #c0c4cc;
  border-color: #c0c4cc;
}

.is-process > .el-step__line {
  border-top: dotted;
}
.content-margin{
  margin: 2% 8% 1%;
}
.content-margin i {
  margin-left: 0px;
}
.t {
  font-size: 20px;
}
.is-finish .el-step__line-inner{
  border-width: 1px !important;
  width: 101% !important;
}
.best .el-step__title.is-wait{
  color: #409EFF !important;
}
.best .el-step__description.is-wait{
  color: #409EFF !important;
}
.el-step__title.is-process{
 color: #409EFF ;
}
.el-step__description.is-process{
  color:#409EFF ;
}
.el-step__head.is-process{
  color: #c0c4cc;
}
.is-finish .step01{
    background-image: url("~@/assets/img/已订舱1.png");
  }
  .is-finish .step02{
    background-image: url("~@/assets/img/待收货1.png");
  }
  .is-finish .step03{
    background-image: url("~@/assets/img/已收货1.png");
  }
  .is-finish .step04{
    background-image: url("~@/assets/img/已安检1.png");
  }
  .is-finish .step05{
    background-image: url("~@/assets/img/拼单管理1.png");
  }
  .is-finish .step06{
    background-image: url("~@/assets/img/已起飞1.png");
  }
  .is-finish .step07{
    background-image: url("~@/assets/img/已降落1.png");
  }
  .is-finish .step08{
    background-image: url("~@/assets/img/已提货1.png");
  }
   .is-finish .step09{
    background-image: url("~@/assets/img/已完成1.png");
  }
  .is-finish .step10{
    background-image: url("~@/assets/img/入库管理(1).png");
    background-size: 96% 100%;
  }
   .el-step.is-center >>> .el-step__line{
    left: 60%;
    right: -41%;
  }
  /* .el-step__head{
    width: 95%;
  } */
/* .is-process .step06{
  background-image: url("~@/assets/img/已起飞1.png")1;
} */
 .el-tag--dark{
   width: 87%;
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;

}

.el-col-offset-1{
  line-height: 30px;
}
.table{
  width: 853px;
  margin: 32px auto 0;
  /* margin-top: 0.16666666666666666rem ;
  margin-left: 3.5%; */
}
.el-table th.el-table__cell>.cell{
  color: #fff;
}
.f1{
  font-size:15px ;

  text-align: left;
  white-space: nowrap;
  padding-left: 20px;
}
.f2{
  font-size: 18px ;
  color: #444;
  font-weight: 600;
  font-family: '微软雅黑';
}
.el-table .cell{
  font-size: 12px;
}
.f3{
  font-size: 13px;
}
.create{
  /* width: 285px; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.el-step.is-center .el-step__description{
  white-space: nowrap;
}
>>> .el-step__line-inner{
  border: none;
  background:#409EFF ;
  height: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/ladingmessage.vue